import { Badge } from '@savvy-kit/components/badge';
import { DateTime } from 'luxon';

import type { MarketingRequest } from './marketing-requests-list';

function getStatusBadgeVariant(status: string): 'secondary-muted' | 'info-muted' | 'primary-muted' | 'warning-muted' {
  switch (status.toLowerCase()) {
    case 'requested':
    case 'needs changes':
      return 'secondary-muted';
    case 'in design':
    case 'in progress':
    case 'compliance review':
      return 'info-muted';
    case 'compliance approved':
    case 'completed':
      return 'primary-muted';
    case 'on hold':
      return 'warning-muted';
    default:
      return 'secondary-muted';
  }
}

function formatDueDate(isoDate: string): string {
  const date = DateTime.fromISO(isoDate).setZone('UTC');
  const currentYear = DateTime.now().year;
  return date.year === currentYear ? date.toFormat('MMM d') : date.toFormat('MM/dd/yy');
}

export function MarketingRequestRow({ request }: { readonly request: MarketingRequest }) {
  const dueDate = request.dueDate !== null ? formatDueDate(request.dueDate) : null;

  return (
    <div className="flex items-center justify-between py-3 px-4">
      <div className="flex items-center gap-2 min-w-0 flex-1 mr-4">
        <p className="text-sm font-medium truncate">{request.title}</p>
        {dueDate && <span className="text-xs text-secondary shrink-0">Due {dueDate}</span>}
      </div>
      <Badge variant={getStatusBadgeVariant(request.status)}>
        {request.status.charAt(0).toUpperCase() + request.status.slice(1).toLowerCase()}
      </Badge>
    </div>
  );
}
